import { Injectable } from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';

@Injectable()
export class ContactService {

  constructor(private http:Http) { } 
    
     newContacto(contacto:string): Promise<String>   {    
    
        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'contacto';    
        return this.http.post(url,contacto,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as String;
          }).catch(this.handleError)
      
    }    
    
    /**
    * Handles error thrown during HTTP call
    * @param error:any
    * @returns {Promise<never>}
    */
    private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); //
    return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/general/contact.service.ts